export default [
  {
    fullName: {
      value: 'Laila Mariel Woods',
      extraInfo:
        'Seems kind, but keeps to herself. Treats PATRICIA like baby. PATRICIA is not baby. Only dangerous computer. Not alive. It annoys me.',
    },
    userId: { value: 'A001', extraInfo: '' },
    rm: { value: '101A', extraInfo: '' },
    age: { value: '33', extraInfo: '' },
    arrival: {
      value: 'N/A',
      extraInfo:
        'One of first new employees during reconstruction. After research, identity checked out. Part of routine.',
    },
    currentOccupation: {
      value: 'Computer Programmer and Systems Operator',
      extraInfo:
        'Only original PATRICIA programmer left. That is not good. Wonder if she will train someone to take over some day.',
    },
    previousOccupation: {
      value: 'N/A',
      extraInfo: 'Helped create PATRICIA. I remember her first day. Was nervous about new job.',
    },
    previousWorkLocation: { value: 'NACS Facility', extraInfo: '' },
    maritalStatus: {
      value: 'Single',
      extraInfo:
        'Family included Lafayette Woods, Father and Catrina Woods, Mother.  Both deceased. She also had little brother, Malik Woods. Was age 24. Now deceased.',
    },
    spouse: { value: 'N/A', extraInfo: '' },
    children: [],
    previousDisciplinaryActions: [],
    medicalRecords: [],
    image: 'eb-personnel-photos-laila.png',
  },
  {
    fullName: {
      value: 'Alexander Ugnius Petroshevych',
      extraInfo: 'Alosha is easier for Americans to pronounce. I hate nickname Alex.',
    },
    userId: { value: 'A002', extraInfo: '' },
    rm: { value: '102A', extraInfo: '' },
    age: { value: '68', extraInfo: '' },
    arrival: {
      value: 'N/A',
      extraInfo: 'I have been here too long, but I never forget first day of work.',
    },
    currentOccupation: { value: 'Head of Security and CyberSecurity', extraInfo: '' },
    previousOccupation: { value: 'N/A', extraInfo: '' },
    previousWorkLocation: { value: 'NACS Facility', extraInfo: '' },
    maritalStatus: { value: 'Widowed', extraInfo: '' },
    spouse: {
      value: 'Nina Vladyslava Petroshevych',
      extraInfo: 'You dream of glory now. Sleep well.',
    },
    children: [
      {
        name: 'Svitlana Sofiya Petroshevych',
        extraInfo: 'My wisdom.',
        status: 'Deceased',
      },
      {
        name: 'Bohdan Ivan Petroshevych',
        extraInfo: "My Bo. You were god's gift to me.",
        status: 'Deceased',
      },
      {
        name: 'Oleksander Pavlo Petroshevych',
        extraInfo: 'My brave warrior. Найменші камені можуть подолати найбільших ворогів.',
        status: 'Deceased',
      },
    ],
    previousDisciplinaryActions: [],
    medicalRecords: [],
    image: 'eb-personnel-photos-alosha.png',
  },
  {
    fullName: {
      value: 'Mathias Gabriel Lind',
      extraInfo:
        'Skittish man. Lets nerves get the best of him. Claims he is better at controlling his fear, but only grave will cure the hunchback. I do not trust him',
    },
    userId: { value: 'A003', extraInfo: '' },
    rm: { value: '103A', extraInfo: '' },
    age: { value: '40', extraInfo: '' },
    arrival: { value: 'N/A', extraInfo: '' },
    currentOccupation: { value: 'Head of Maintenance, Chief Technician', extraInfo: '' },
    previousOccupation: { value: 'N/A', extraInfo: '' },
    previousWorkLocation: { value: 'NACS Facility', extraInfo: '' },
    maritalStatus: { value: 'Widowed', extraInfo: '' },
    spouse: { value: 'Andrea Lind', extraInfo: '' },
    children: [],
    previousDisciplinaryActions: [
      {
        text: 'Caught engaging in rations black market. Contraband Reclaimed. No further actions.',
      },
      {
        text:
          'Caught smoking. Unclear how cigarettes obtained. Kim is likely suspect. No actions taken.',
      },
    ],
    medicalRecords: [],
    image: 'eb-personnel-photos-mathias.png',
  },
  {
    fullName: {
      value: 'Cyril Farrahmand',
      extraInfo:
        'Pretty boy. Cares too much how he looks. Funny. Not as funny as he thinks. Always seems calm. I do not trust him.',
    },
    userId: { value: 'A004', extraInfo: '' },
    rm: { value: '104A', extraInfo: '' },
    age: { value: '45', extraInfo: '' },
    arrival: { value: 'N/A', extraInfo: '' },
    currentOccupation: { value: 'Psychologist, Conflict Mediator', extraInfo: '' },
    previousOccupation: { value: 'N/A', extraInfo: '' },
    previousWorkLocation: { value: 'NACS Facility', extraInfo: '' },
    maritalStatus: { value: 'Single', extraInfo: '' },
    spouse: { value: 'N/A', extraInfo: '' },
    children: [],
    previousDisciplinaryActions: [
      {
        text: 'No known actions requiring discipline. Only matter of time. No one is perfect.',
        highlight: true,
      },
    ],
    medicalRecords: [],
    image: 'eb-personnel-photos-cyril.png',
  },
  {
    fullName: { value: 'Shepard Oswald', extraInfo: '' },
    userId: { value: 'A007', extraInfo: '' },
    rm: { value: '105A', extraInfo: '' },
    age: { value: '39', extraInfo: '' },
    arrival: {
      value: '4',
      extraInfo:
        'First outsider to find facility. I let him in. He was clean. No virus. Some blood. Looked like he was in a fight. He is good at surviving. I do not trust him.',
    },
    currentOccupation: { value: 'Head of Law Enforcement', extraInfo: '' },
    previousOccupation: {
      value: 'Agent of the Federal Bureau of Investigation',
      extraInfo: 'After routine research, FBI badge checked out.',
    },
    previousWorkLocation: { value: 'Washington, D.C.', extraInfo: '' },
    maritalStatus: { value: 'Widowed', extraInfo: '' },
    spouse: { value: 'Elizabeth Collins Oswald', extraInfo: '' },
    children: [
      {
        name: 'Julia Oswald',
        extraInfo: '',
        status: 'Deceased',
      },
    ],
    previousDisciplinaryActions: [],
    medicalRecords: [],
    image: 'eb-personnel-photos-oswald.png',
  },
  {
    fullName: {
      value: 'Persephone Sophia Grace',
      extraInfo:
        'Smart. Good medic. Kind heart. Will get us all killed. Wastes medicine on lost causes. Naive. I do not trust her.',
    },
    userId: { value: 'B005', extraInfo: '' },
    rm: { value: '201B', extraInfo: '' },
    age: { value: '31', extraInfo: '' },
    arrival: { value: 'N/A', extraInfo: '' },
    currentOccupation: { value: 'Medic', extraInfo: '' },
    previousOccupation: {
      value: 'N/A',
      extraInfo:
        'Was paramedic at the Oregon Health and Sciences University Hospital before employed here.',
    },
    previousWorkLocation: { value: 'NACS Facility', extraInfo: '' },
    maritalStatus: { value: 'Single', extraInfo: '' },
    spouse: { value: 'N/A', extraInfo: '' },
    children: [],
    previousDisciplinaryActions: [
      {
        text: "Ignoring Supervisor's Order.",
      },
      {
        text: 'Using medical supplies in unapproved manner. 1 week probation.',
      },
      {
        text: 'Using medical supplies in unapproved manner. 2 week probation.',
      },
      { text: 'Using medical supplies in unapproved manner. 4 week probation.' },
    ],
    medicalRecords: [],
    image: 'eb-personnel-photos-persephone.png',
  },
  {
    fullName: {
      value: 'Anthony Whelan',
      extraInfo:
        'Likes name "Anto." Weird little man. Good worker. Knows his field. Good at faking smile. I do not trust him.',
    },
    userId: { value: 'B006', extraInfo: '' },
    rm: { value: '202B', extraInfo: '' },
    age: { value: '39', extraInfo: '' },
    arrival: { value: 'N/A', extraInfo: '' },
    currentOccupation: {
      value: 'Botanist',
      extraInfo:
        'Produces food for facility. Experiments with plants for potential oxygen source for facility. I like in case outside changes. It is good work.',
    },
    previousOccupation: { value: 'N/A', extraInfo: '' },
    previousWorkLocation: {
      value: 'NACS Facility',
      extraInfo:
        'Contracted only short time before attack to install garden and hydroponic system.',
    },
    maritalStatus: { value: 'Single', extraInfo: '' },
    spouse: { value: 'N/A', extraInfo: '' },
    children: [],
    previousDisciplinaryActions: [
      { text: 'Multiple complaints about abrasive personality, no action taken.' },
    ],
    medicalRecords: [],
    image: 'eb-personnel-photos-anthony.png',
  },
  {
    fullName: { value: 'Simone Ruth Thomas', extraInfo: '' },
    userId: { value: 'B012', extraInfo: '' },
    rm: { value: '204B', extraInfo: '' },
    age: { value: '47', extraInfo: '' },
    arrival: { value: '27', extraInfo: '' },
    currentOccupation: { value: 'Head of Biochemical Research and Development', extraInfo: '' },
    previousOccupation: {
      value: 'Biochemical engineer',
      extraInfo: 'Doctorate in Biology and Biochemical Engineering. Worked for government.',
    },
    previousWorkLocation: {
      value: 'Baltimore, Maryland',
      extraInfo: 'Research project affiliated with this base. That is how she knew to come here.',
    },
    maritalStatus: { value: 'Widowed', extraInfo: '' },
    spouse: { value: 'Levi Thomas', extraInfo: 'Professor' },
    children: [
      {
        name: 'Noah Thomas',
        extraInfo: '',
        status: 'Deceased',
      },
    ],
    previousDisciplinaryActions: [
      {
        text: 'No disciplinary actions',
      },
      {
        text: 'I see her sneak around and use Jeremy to carry messages. I will keep an eye on her.',
        highlight: true,
      },
    ],
    medicalRecords: [],
    image: 'eb-personnel-photos-simone.png',
  },
  {
    fullName: {
      value: 'Caitlin “Sister Adataneses” Rossiter',
      extraInfo:
        'Gave herself that name the week she arrived. Said the world was beginning again, and so would she.',
    },
    userId: { value: 'B013', extraInfo: '' },
    rm: { value: '204B', extraInfo: '' },
    age: {
      value: '58',
      extraInfo: '',
    },
    arrival: {
      value: '27',
      extraInfo: '',
    },
    currentOccupation: { value: 'Religious Figure, General Task Management ', extraInfo: '' },
    previousOccupation: { value: 'Nun', extraInfo: '' },
    previousWorkLocation: {
      value: 'Webster, Massachusetts',
      extraInfo: 'Was the Abbess of Our Lady of Profound Sorrow',
    },
    maritalStatus: {
      value: 'Single',
      extraInfo: 'Family still unknown. Divulges little about herself.',
    },
    spouse: { value: 'N/A', extraInfo: '' },
    children: [],
    previousDisciplinaryActions: [
      {
        text: 'Has no disciplinary actions. Or has not yet been caught. I do not trust her. ',
        highlight: true,
      },
    ],
    medicalRecords: [],
    image: 'eb-personnel-photos-sister-ada.png',
  },
  {
    fullName: { value: 'Jeremy Oliver Reid', extraInfo: 'Болту́н - нахо́дка для шпио́на' },
    userId: { value: 'B017', extraInfo: '' },
    rm: { value: '203B', extraInfo: '' },
    age: {
      value: '12',
      extraInfo:
        'Lived almost half his life here. I take him under wing and teach him how to be strong. He needs it.',
    },
    arrival: {
      value: '32',
      extraInfo:
        'I do not understand how he survived for that long on the outside. Like Mr. Magoo, this one.',
    },
    currentOccupation: { value: 'Courier', extraInfo: '' },
    previousOccupation: { value: 'N/A', extraInfo: 'Lived with parents.' },
    previousWorkLocation: { value: 'Occupied Long Island, New York', extraInfo: '' },
    maritalStatus: {
      value: 'Single',
      extraInfo: 'Family included Eugene Reid, Father and Lillian Reid, Mother. Both deceased.',
    },
    spouse: { value: 'N/A', extraInfo: '' },
    children: [],
    previousDisciplinaryActions: [
      {
        text: 'Reprimanded for Loss of Important Council Documentation.',
      },
      {
        text: 'Cyril was greatly distressed that his game of hangman with the Sister was lost.',
        highlight: true,
      },
      { text: 'Reprimanded for Accidental Damage to Facility Equipment' },
      { text: 'Reprimanded for Possession of Contraband' },
      { text: 'Reprimanded for Loss of Important Council Documentation' },
      { text: 'Reprimanded for Loss of Important Council Documentation' },
      { text: 'Reprimanded for Accidental Damage to Facility Equipment' },
    ],
    medicalRecords: [
      { text: 'Treated for Misc. Minor Injuries by Persephone Grace' },
      { text: 'Treated for Misc. Minor Injuries by Persephone Grace' },
      { text: 'Treated for Misc. Minor Injuries by Persephone Grace' },
      {
        text:
          'Saw Persephone write, "Gosh, is this kid clumsy. Please never let him volunteer for any Expeditions" on his personal record. I think Kim knew this already.',
        highlight: true,
      },
    ],
    image: 'eb-personnel-photos-jeremy.png',
  },
  {
    fullName: {
      value: 'Jordan Makani Kim',
      extraInfo: 'Spirited. Too spirited for her own good. But I admire her дерзость.',
    },
    userId: { value: 'B037', extraInfo: '' },
    rm: { value: '203B', extraInfo: '' },
    age: { value: '26', extraInfo: '' },
    arrival: { value: '98', extraInfo: '' },
    currentOccupation: {
      value: 'Head of Expeditions, Resource Scouting and Retrieval Missions',
      extraInfo:
        'Trained six people to go on missions with. Only people she trusts. Good. And she is brave. Braver than most to go outside.',
    },
    previousOccupation: { value: 'Personal Trainer', extraInfo: '' },
    previousWorkLocation: {
      value: 'Waiʻanae, Hawaii',
      extraInfo:
        'Her hometown. I asked once, why she is an ocean away from home when world ended. She said she was hiking in Rocky Mountains.',
    },
    maritalStatus: {
      value: 'Single',
      extraInfo:
        'Family included: Phillip Kim, Father. Maleah Kim, Mother. Jamie Kim, Brother. All presumed deceased, but not confirmed. Also had very big dog named Dwayne "The Dog" Johnson when she came here. Also now Deceased. Was old, but good dog.',
    },
    spouse: { value: 'N/A', extraInfo: '' },
    children: [],
    previousDisciplinaryActions: [
      {
        text:
          'Reprimanded for Disorderly Conduct. Very loud fight with D047 over what she is calling "entitled attitude," he was asking her to find a mini-fridge on next Expedition.',
      },
      { text: 'Reprimanded for Possession and Distribution of Contraband' },
      { text: 'Reprimanded for Disobeying Council Orders' },
      { text: 'Reprimanded for Possession of Contraband' },
      { text: 'Reprimanded for Distribution of Contraband' },
      { text: 'Reprimanded for Disobeying Council Orders' },
      {
        text: 'Am, frankly, very surprised Agent Oswald does not catch her doing this more.',
        highlight: true,
      },
    ],
    medicalRecords: [
      { text: 'Treated for Misc. Minor Injuries by Persephone Grace' },
      { text: 'Treated for Misc. Minor Injuries by Persephone Grace' },
      { text: 'Treated for Fractured Ulna by Persephone Grace' },
      { text: 'Treated for Misc. Minor Injuries by Persephone Grace' },
      { text: 'Treated for Misc. Minor Injuries by Persephone Grace' },
      { text: 'Treated for Misc. Minor Injuries by Persephone Grace' },
      { text: 'Given three stitches for substantial injury to leg by Persephone Grace' },
    ],
    image: 'eb-personnel-photos-jordan.png',
  },
]
